(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      // Der Header aendert seine Hoehe beim Scrollen (72 auf 58 px). Ohne das
      // hier bliebe --header-height auf dem Startwert stehen, und davon haengt
      // `shopify-section-header-hidden` mit top: calc(-1 * var(--header-height))
      // ab: der Header wuerde beim Wegblenden nicht vollstaendig verschwinden.
      // ResizeObserver statt transitionend, weil der pro Property feuert und
      // auch geladene Schriften oder ein Umbruch die Hoehe aendern koennen.
      if ('ResizeObserver' in window) {
        this.heightObserver = new ResizeObserver(() => this.setHeaderHeight());
        this.heightObserver.observe(this);
      }

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      // this ist <sticky-header class="header-wrapper">, also der sichtbare
      // Header. Frueher wurde this.header genommen, das ist die umgebende
      // Section: die behaelt beim Schrumpfen ihre Ausgangshoehe (73 statt 59)
      // und --header-height blieb dadurch zu gross. Davon haengt
      // `shopify-section-header-hidden` mit top: calc(-1 * var(--header-height)) ab.
      document.documentElement.style.setProperty('--header-height', `${this.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
      if (this.heightObserver) this.heightObserver.disconnect();
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      const active = document.activeElement;
      if (active && active.classList.contains('search__input')) {
        return;
      }
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      if (this.searchModal) {
        this.searchModal.close(false);
      }
    }
  }

  customElements.define('sticky-header', StickyHeader);

  /* ➜ HOVER-DROPDOWN NUR FÜR "Katalog" / "Produkte" AUF DESKTOP */
  document.addEventListener('DOMContentLoaded', function() {
    const desktopQuery = window.matchMedia('(min-width: 990px)');

    function setupKatalogHover() {
      const detailsElements = document.querySelectorAll('.header__inline-menu header-menu details');

      detailsElements.forEach((detailsEl) => {
        if (detailsEl.dataset.katalogHoverBound === 'true') return;

        const summary = detailsEl.querySelector('summary');
        if (!summary) return;

        const labelSpan = summary.querySelector('span');
        const labelText = (labelSpan ? labelSpan.textContent : summary.textContent).trim().toLowerCase();

        // Menüpunkt "Katalog" ODER "Produkte"
        if (labelText !== 'katalog' && labelText !== 'produkte') return;

        detailsEl.dataset.katalogHoverBound = 'true';

        detailsEl.addEventListener('mouseenter', () => {
          if (!desktopQuery.matches) return;
          detailsEl.setAttribute('open', 'open');
        });

        detailsEl.addEventListener('mouseleave', () => {
          if (!desktopQuery.matches) return;
          detailsEl.removeAttribute('open');
        });
      });
    }

    setupKatalogHover();

    if (desktopQuery.addEventListener) {
      desktopQuery.addEventListener('change', setupKatalogHover);
    }
  });

  /* Drawer-Menü */
  document.addEventListener('DOMContentLoaded', () => {
    const drawer = document.getElementById('Details-menu-drawer-container');
    if (!drawer) return;

    let savedScrollY = 0;

    const cleanupScrollLock = () => {
      document.documentElement.classList.remove('overflow-hidden');
      document.body.classList.remove('overflow-hidden', 'overflow-hidden-tablet');

      const wasFixed = document.body.style.position === 'fixed';
      document.body.style.overflow = '';
      document.body.style.position = '';
      document.body.style.top = '';
      document.body.style.width = '';

      if (wasFixed) window.scrollTo(0, savedScrollY);
    };

    const openDefaultAccordion = () => {
      const prod = drawer.querySelector('details[data-default-open="true"]');
      if (prod) prod.open = true;
    };

    // Produkte: Klick nur als Accordion, nicht als Submenu-Panel interpretieren lassen
    document.addEventListener(
      'click',
      (e) => {
        const summary = e.target.closest('#Details-menu-drawer-container details[data-inline-accordion="true"] > summary');
        if (summary) e.stopPropagation();

        const closeBtn = e.target.closest('.menu-drawer__close-menu-btn, .menu-drawer__close-btn, .menu-drawer__close-button');
        if (closeBtn) setTimeout(cleanupScrollLock, 0);
      },
      true
    );

    drawer.addEventListener('toggle', () => {
      if (drawer.open) {
        savedScrollY = window.scrollY || window.pageYOffset || 0;

        // nach Drawer-Open, damit Theme-Resets zuerst passieren können
        requestAnimationFrame(openDefaultAccordion);
        setTimeout(openDefaultAccordion, 50);
      } else {
        cleanupScrollLock();
      }
    });
  });


  } catch(e) { console.error(e); }
})();
})();
